import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useAppSelector } from "../store/hooks";
import { AppState } from "../store/store";

export default function GlobalLoader(props: any) {
  const loginType = useAppSelector(
    (state: AppState) => state.login && state.login.loginResponse.userType
  );

  return (
    <div>
      <Backdrop
        sx={{ color: "#f7dcc4", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={props.loading}
      >
        <CircularProgress size={50} className="action-button-loader" />
      </Backdrop>
    </div>
  );
}
